import React, { Component } from "react"
import {
  InputCustom,
  SelectWithSearch,
  HttpError,
  TextArea
} from "../../components"
import * as ApiHelper from "../../ApiHelper"
import Util from "../../Util"
import { LoadModal } from "../modais"

export default class RelatorioAtestadoDeCapacidadeTecnicaForm extends Component {
  constructor() {
    super()
    this.onChangeData = this.onChangeData.bind(this)
    this.reset = this.reset.bind(this)
    this.handleErrors = this.handleErrors.bind(this)
    this.onChangeServico = this.onChangeServico.bind(this)
    this.onChangeSecretario = this.onChangeSecretario.bind(this)
    this.onChangeContrato = this.onChangeContrato.bind(this)
    this.getContratos = this.getContratos.bind(this)
    this.sendForm = this.sendForm.bind(this)
    this.toggleLoadModal = this.toggleLoadModal.bind(this)
    this.state = {
      showLoad: false,
      data: "",
      servico: "",
      secretario: "",
      contrato: "",
      contratos: [],
      formError: ""
    }
  }
  reset() {
    this.setState({
      data: "",
      servico: "",
      secretario: "",
      contrato: ""
    })
  }

  componentWillMount() {
    this.getContratos()
  }
  getContratos() {
    ApiHelper.getAllContratos((contratos, error) => {
      if (contratos) {
        var mapped = Util.mapContratos(contratos)
        mapped.shift()
        this.setState({
          contratos: mapped
        })
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  onChangeContrato(event) {
    this.setState({
      contrato: event,
      contrato_idError: ""
    })
  }
  onChangeServico(e) {
    var newValue = e.target.value
    this.setState({
      servico: newValue,
      servicoError: ""
    })
  }
  onChangeSecretario(e) {
    var newValue = e.target.value
    this.setState({
      secretario: newValue,
      secretarioError: ""
    })
  }
  onChangeData(value) {
    var newValue = value
    this.setState({
      data: newValue,
      dataError: ""
    })
  }

  sendForm(event) {
    event.preventDefault()
    var params = {
      tipo_relatorio: "Atestado de capacidade técnica",
      contrato_id:
        this.state.contrato === undefined || this.state.contrato === null
          ? null
          : this.state.contrato.value,
      data: Util.dateOnly(this.state.data),
      servico: this.state.servico,
      secretario: this.state.secretario
    }
    this.toggleLoadModal()
    ApiHelper.getRelatorioWith(params, (relatorio, error) => {
      this.toggleLoadModal()
      if (relatorio) {
        var url = URL.createObjectURL(relatorio)
        var tempLink = document.createElement("a")
        tempLink.href = url
        tempLink.setAttribute("download", "Atestado de capacidade técnica.pdf")
        document.body.appendChild(tempLink)
        tempLink.click()
        document.body.removeChild(tempLink)
      } else {
        this.handleErrors(error)
        this.setState({
          formError: "Não existem baixas nesse período"
        })
      }
    })
  }
  handleErrors(errors) {
    var errorsJSON = JSON.parse(errors)
    var errorsValue = errorsJSON.errors
    var errorsState = {}
    for (var key in errorsValue) {
      errorsState[key + "Error"] = errorsValue[key][0]
    }
    this.setState(errorsState)
  }
  toggleLoadModal() {
    this.setState({
      showLoad: !this.state.showLoad
    })
  }
  render() {
    if (this.state.httpError) {
      return (
        <div className="row card" style={{ marginTop: 100 }}>
          <HttpError
            message={this.state.httpError.message}
            status={this.state.httpError.status}
          />
        </div>
      )
    }
    return (
      <div className="card card-content">
        <div className="row ">
          <LoadModal
            onClose={this.toggleLoadModal}
            show={this.state.showLoad}
          />
          <SelectWithSearch
            sizeClass="col-md-8"
            options={this.state.contratos}
            label="Contrato"
            error={this.state.contrato_idError}
            placeholder="Selecione um contrato ou deixe em branco para selecionar todos"
            onChange={this.onChangeContrato}
            value={this.state.contrato}
          />
        </div>
        <div className="row">
          <InputCustom
            sizeClass="col-md-3"
            type="text"
            label="Nome do(a) secretário(a)"
            error={this.state.secretarioError}
            onChange={this.onChangeSecretario}
            value={this.state.secretario}
          />
          <InputCustom
            sizeClass="col-md-3"
            type="date"
            label="Data do atestado"
            error={this.state.dataError}
            onChange={this.onChangeData}
            value={this.state.data}
          />
        </div>
        <div className="row">
          <TextArea
            onChange={this.onChangeServico}
            sizeClass="col-md-12"
            label="Descrição dos serviços prestados"
            value={this.state.servico}
            error={this.state.servicoError}
          />
        </div>

        <div className="row">
          <button
            onClick={this.sendForm}
            type="submit"
            className="btn btn-primary pull-left"
            data-background-color="as-blue"
          >
            Gerar
          </button>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/documentos/RelatorioAtestadoDeCapacidadeTecnicaForm.js